import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("UI error boundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="card" style={{ padding: "1.5rem", margin: "2rem auto", maxWidth: "640px" }}>
          <h2 style={{ marginTop: 0 }}>Something went wrong</h2>
          <p style={{ color: "var(--muted)" }}>
            The page hit an unexpected error. Try refreshing. If the problem persists, contact support with the time
            this occurred.
          </p>
          <pre style={{ fontSize: "0.85rem", overflow: "auto" }}>{this.state.error.message}</pre>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
